import { render, staticRenderFns } from "./PaginationVcDemo.vue?vue&type=template&id=2bc8a39f&scoped=true&"
import script from "./PaginationVcDemo.vue?vue&type=script&lang=js&"
export * from "./PaginationVcDemo.vue?vue&type=script&lang=js&"
import style0 from "./PaginationVcDemo.vue?vue&type=style&index=0&id=2bc8a39f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc8a39f",
  null
  
)

export default component.exports